import * as Sentry from "@sentry/browser";
import Alpine from "alpinejs";
import htmx from "htmx.org";

import {
  handleAfterRequest,
  handleBeforeRequest,
} from "../components/spinners";
import { handleBFCache } from "../events/bfcache";
import { initializeDOMReady } from "../utils/domReady";
import { initializeLucideIcons } from "./lucide";

// Initialize Sentry if config is available from Django
if (window.SENTRY_CONFIG && window.SENTRY_CONFIG.dsn) {
  try {
    Sentry.init({
      dsn: window.SENTRY_CONFIG.dsn,
      environment: window.SENTRY_CONFIG.environment || "development",
      sendDefaultPii: true,
    });

    // Make Sentry available globally for error boundaries
    window.Sentry = Sentry;
  } catch (error) {
    console.error("Failed to initialize Sentry:", error);
    // Application continues to work even if Sentry fails
  }
}

// Configure htmx
window.htmx = htmx;
if (htmx.config) {
  (htmx.config as Record<string, unknown>).useTemplateFragments = true;
}

window.Alpine = Alpine;

const initializeAlpine = (): void => {
  window.Alpine.start();
};

// Initialize on DOM ready
initializeDOMReady([initializeAlpine, initializeLucideIcons]);

// Event listeners
window.addEventListener("pageshow", handleBFCache);

document.body.addEventListener("htmx:beforeRequest", handleBeforeRequest);
document.body.addEventListener("htmx:afterRequest", handleAfterRequest);

document.addEventListener("htmx:load", (_) => {
  initializeLucideIcons();
});
